import React from 'react';

/**
 * A label sitting above its control.
 *
 * Thirteen screens had their own. Three variants were in play: a plain div
 * with `text-xs font-medium text-gray-600`, a <label> with the same, and a
 * flex-column <label> with a `text-[10px] uppercase` caption. The uppercase
 * one was only ever used in dense filter bars, so it survives here as
 * `size="caption"` rather than being thrown away.
 *
 * It renders a real <label> and wires htmlFor/id when given one, which none of
 * the div-based clones did — those left screen-reader users with an unlabelled
 * input, and cost sighted users the click-the-label-to-focus behaviour.
 */
const Field = ({ label, htmlFor, hint, error, required, size = 'default', children }) => {
  const Wrapper = htmlFor ? 'label' : 'div';

  return (
    <div className="flex flex-col gap-1">
      <Wrapper
        {...(htmlFor ? { htmlFor } : {})}
        className={
          size === 'caption'
            ? 'text-[10px] font-medium uppercase tracking-wide text-gray-500'
            : 'text-xs font-medium text-gray-600'
        }>
        {label}
        {required && (
          <span className="ml-0.5 text-danger" aria-hidden="true">
            *
          </span>
        )}
      </Wrapper>

      {children}

      {/* Hint gives way to the error rather than stacking — two lines of small
          grey text under one input is where forms start looking noisy. */}
      {error ? (
        <span className="text-xs text-danger">{error}</span>
      ) : hint ? (
        <span className="text-xs text-gray-500">{hint}</span>
      ) : null}
    </div>
  );
};

export default Field;
